import { render, staticRenderFns } from "./Sources.vue?vue&type=template&id=4b7e6cdf&scoped=true&"
import script from "./Sources.vue?vue&type=script&lang=js&"
export * from "./Sources.vue?vue&type=script&lang=js&"
import style0 from "./Sources.vue?vue&type=style&index=0&id=4b7e6cdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e6cdf",
  null
  
)

export default component.exports